import React, { Fragment } from "react";
import { Col, Row } from "antd";
import DiscussionPlayer from "./DiscussionPlayer";
import { Navigate } from "react-router-dom";

const Announcements = ({ event, panelFound, teamFound, id }) => {
  if (!panelFound && !teamFound) {
    return <Navigate to="/" />; // Redirect to home or another page if the user is not team member and not a creator
  }

  return (
    <Fragment>
      <Row className="rowPadding" justify="center">
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 24, order: 3 }}
          lg={{ span: 12, order: 2 }}>
          {Object.keys(event).length > 0 && (
            <DiscussionPlayer
              event={event}
              eventId={id}
              panelFound={panelFound}
              teamFound={teamFound}
            />
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

export default Announcements;
